module.exports = __webpack_public_path__ + "829e2684163d93cf055357a57b4da0f1.svg";